import React, {Component} from 'react';

//import {connect} from "react-redux";

class CsodTableRow extends Component {

    render() {
        const {rowItem} = this.props;
        return (
            <tr id="ctl00_ContentPlaceHolder1_rptEvent_ctl01_rptRow">
                {Object.values(rowItem).map((item, index) => {

                    if (Object.values(rowItem).length === (index + 1)) {
                        //last item
                        return (
                            <td key={index} className="cso-tbl-std-td col c">
                                <a data-tag="Linkbutton1" id="ctl00_ContentPlaceHolder1_rptEvent_ctl01_Linkbutton1"
                                   className="cso-vlgn-t"
                                   href="AdminEmailEdit.aspx?qs=%5e%5e%5erKEuS9sdJQmPs4Gop0GN2dGSvQQexpCONNhg2EZnmNe5JmbuSVqkstaMdkL%2fBtHRzjPdU3DMhr%2fpVDHyKwMON2dkkr2vrt9KG77ELEXM8h%2f%2bOgGgB3Ii%2bau4ZJnysyLHRPgulNNSwB9aOVCCOXpMUCJdodUZy1o3hfps4au2YWO1L71ooVB3%2fXZdENuhh4VdDxR97e5KltLlrNf0nmI7Vw%3d%3d"
                                   title="Add Email">
                                    <i className="fa-icon-envelope cso-text-large cso-vlgn-m"
                                       title="Add Email" alt="Add Email"></i>
                                </a>
                            </td>
                        )
                    }

                    if (index === 0) {
                        return (
                            <td key={index} id="ctl00_ContentPlaceHolder1_rptEvent_ctl01_title"
                                className="cso-tbl-std-td col">
                                <input type="image" name="ctl00$ContentPlaceHolder1$rptEvent$ctl01$img"
                                       id="ctl00_ContentPlaceHolder1_rptEvent_ctl01_img"
                                       src="../images/bullet_plus.gif" alt="Expand" style={
                                    {borderWidth: 0}
                                }
                                       vspace="2"/>
                                <span id="ctl00_ContentPlaceHolder1_rptEvent_ctl01_eventTitle">
                                    {item}
                                </span>
                            </td>
                        );
                    } else {
                        return (
                            <td key={index} className="cso-tbl-std-td col">
                                {item}
                            </td>
                        );
                    }
                })}
            </tr>
        );
    }
}

// const mapStateToProps = (state) => {
//     return {
//         version: state.layout.version,
//     };
// };
//
// const mapDispatchToProps = (dispatch) => {
//     return {
//         setVersion: () => dispatch(setVersion()),
//     };
// };

//Widget = connect(mapStateToProps, mapDispatchToProps)(FrontLayout)

export default CsodTableRow;


// WEBPACK FOOTER //
// ./src/widgets/components/Csod/CsodTableRow.js